import { post } from 'src/tools/server';

const createTag = (tag) => {
  return post('/portal/productTag', tag, {});
};

export { createTag };
